export default __webpack_public_path__ + "static/media/facebook.c997eb7d.svg";